export const hi = {
  translation: {
    common: {
      sessionExpiredTab: "सत्र समाप्त हो गया। आप यह टैब बंद कर सकते हैं।",
      sessionExpiredApp: "सत्र समाप्त हो गया। वापस जा रहे हैं...",
    },
    tilt: {
      title: 'झुकाव पकड़ा!',
      message: 'खेलते रहने के लिए पोर्ट्रेट मोड में जाएँ',
    },
    settings: {
      soundSettings: 'ध्वनि सेटिंग्स',
      music: 'संगीत',
      effects: 'प्रभाव',
      off: 'बंद',
      disableAnimations: 'एनिमेशन बंद करें',
    },
    game: {
      connecting: 'डमी उपयोगकर्ता प्राप्त किया जा रहा है (देव-सत्र)…',
      connectingNote: 'यह बिल्ड स्टैंडअलोन चल रही है, असली ऐप में यह स्क्रीन नहीं दिखेगी।',
      loading: 'खेल शुरू हो रहा है…',
      calculatingResult: 'परिणाम की गणना हो रही है…',
      level: 'स्तर {number}',
      skipLevel: 'स्तर छोड़ें',
      solved: '✓ हल हो गया!',
      loadingNext: 'अगला राउंड लोड हो रहा है…',
      processing: 'प्रोसेस हो रहा है…',
      retryConnection: 'फिर से कनेक्ट करें',
      demo: 'डेमो',
      preview: 'प्रिव्यू',
      done: 'हो गया',
      boardOf: 'बोर्ड {current} में से {total}',
      clear: 'क्लियर !',
      greatWork: 'बहुत बढ़िया! अब असली खेल खेलते हैं।',
      loadingNextBoard: 'अगला बोर्ड लोड हो रहा है…',
      hintBanner: 'खाली जगह के पास की टाइल टैप करके स्लाइड करें',
      memorize: 'याद करें! {remaining}s',
      loadingImage: 'लोड हो रहा है…',
      autoSolve: 'ऑटो हल',
      puzzleEditor: 'पज़ल एडिटर',
      demoCompleteBtn: 'होम पर वापस जाएँ',
      demoCleared: 'डेमो पूरा हुआ',
      boardCompleted: 'बोर्ड पूरा हुआ!',
      levelComplete: 'लेवल पूरा',
      allPiecesSolved: 'सभी टुकड़े जोड़ दिए!',
      nextRound: 'अगला राउंड',
    },
    auth: {
      failed: 'प्रमाणीकरण विफल',
      failedTitle: 'प्रमाणीकरण विफल',
    },
    instructions: {
      labels: {
        playNow: 'अभी खेलें',
        learnHowToPlay: 'कैसे खेलें?',
        starting: 'शुरू हो रहा है...',
      },
      stageInstructions: {
        gameLabel: 'गेम {stage}',
        statusLabel: 'सक्रिय',
        gameTitle: 'स्लाइडिंग पज़ल',
        slides: [
          {
            id: 'description',
            title: 'कैसे खेलें',
            description:
              'स्लाइडिंग पज़ल एक क्लासिक लॉजिक गेम है जहाँ आपको टाइल्स को पुनर्व्यवस्थित करके एक छिपी हुई तस्वीर को पुनर्निर्मित करना होता है। टाइल्स को खाली स्लॉट में ले जाकर पज़ल हल करें।',
            items: [
              {
                id: 'observe',
                title: 'देखें',
                description: 'तस्वीर के फेरबदल होने से पहले उसे ध्यान से देखें।',
                variant: 'step',
              },
              {
                id: 'memorize',
                title: 'याद करें',
                description: 'टाइल्स की मूल व्यवस्था याद रखें।',
                variant: 'step',
              },
              {
                id: 'solve',
                title: 'हल करें',
                description: 'टाइल्स को खाली जगह में स्लाइड करके तस्वीर को फिर से बनाएँ।',
                variant: 'step',
              },
              {
                id: 'timer',
                title: 'समय से पहले',
                description: 'कुल समय समाप्त होने से पहले सभी राउंड पूरे करें!',
                variant: 'step',
              },
            ],
          },
          {
            id: 'scoring',
            title: 'स्कोरिंग नियम',
            description: 'जानें कि अपना स्कोर कैसे अधिकतम करें और लीडरबोर्ड पर चढ़ें।',
            items: [
              {
                id: 'round-points',
                title: 'राउंड पूरा',
                description: 'हर पज़ल हल करने पर बेस पॉइंट मिलते हैं।',
                variant: 'step',
              },
              {
                id: 'time-bonus',
                title: 'समय बोनस',
                description: 'जितनी जल्दी हल करेंगे, उतना ज़्यादा टाइम बोनस मिलेगा।',
                variant: 'step',
              },
              {
                id: 'moves',
                title: 'कदमों की दक्षता',
                description: 'कम कदमों में हल करने से आपकी अंतिम रैंकिंग प्रभावित हो सकती है।',
                variant: 'step',
              },
              {
                id: 'total-score',
                title: 'कुल स्कोर',
                description: 'आपका स्कोर राउंड पॉइंट्स और टाइम बोनस का योग है।',
                variant: 'step',
              },
            ],
          },
          {
            id: 'anti-cheat',
            title: 'निष्पक्ष खेल नियम',
            description: 'सभी खिलाड़ियों के लिए निष्पक्ष प्रतियोगिता सुनिश्चित करने हेतु इन दिशानिर्देशों का पालन करें:',
            items: [
              {
                id: 'bot',
                title: 'कोई स्वचालित टूल या स्क्रिप्ट नहीं',
                description: 'बॉट का उपयोग अयोग्यता का कारण बनेगा।',
                variant: 'rule',
              },
              {
                id: 'accounts',
                title: 'प्रति खिलाड़ी एक अकाउंट',
                description: 'कई अकाउंट की अनुमति नहीं है।',
                variant: 'rule',
              },
              {
                id: 'connection',
                title: 'स्थिर इंटरनेट कनेक्शन',
                description: 'सिंक समस्याओं से बचने के लिए अपना कनेक्शन स्थिर रखें।',
                variant: 'rule',
              },
            ],
          },
        ],
      },
    },
    offline: {
      connectionLost: "कनेक्शन टूट गया",
      youAreOffline: "आप ऑफलाइन हैं",
      message: "जारी रखने के लिए इंटरनेट आवश्यक है। अपना नेटवर्क जांचें और पुनः प्रयास करें।",
      retry: "पुनः प्रयास करें",
    },
    results: {
      success: {
        scoreLabel: 'आपका स्कोर',
        chipLabel: 'बहुत बढ़िया!',
        headingLeading: 'शाबाश! आपने पज़ल पूरा किया',
        headingHighlight: '',
        headingTrailing: '',
        subheading: 'आगे के खेलों में भी इसी तरह खेलते रहें।',
        progressLabel: 'प्रगति',
        progressSuffixLabel: 'खेल पूरे हुए',
        ctaLabel: 'जारी रखें',
      },
      failure: {
        scoreLabel: 'आपका स्कोर',
        chipLabel: 'कोशिश की आपने!',
        headingLeading: 'चिंता न करें, अगले खेल में',
        headingHighlight: ' फिर से कोशिश करें!',
        headingTrailing: '',
        subheading: 'अभ्यास जारी रखें, अगली बार ज़रूर होगा!',
        progressLabel: 'प्रगति',
        progressSuffixLabel: 'खेल पूरे हुए',
        ctaLabel: 'जारी रखें',
      },
      exitCloseTabHint: 'अब आप इस टैब को सुरक्षित रूप से बंद कर सकते हैं।',
      exitUseAppBackHint: 'अब आप ऐप पर वापस जा सकते हैं।',
      sessionExpired: 'आपका सत्र समाप्त हो गया है। कृपया फिर से प्रयास करें.',
    },
  },
} as const;
